import { supabase } from "@/integrations/supabase/client";

// Fonction pour générer un token unique
export const generateUniqueToken = (): string => {
  // Générer un token aléatoire
  const randomPart = Math.random().toString(36).substring(2, 15);
  const timestampPart = Date.now().toString(36);
  return `${randomPart}${timestampPart}`;
};

// Créer un token pour une action liée à un rendez-vous
export const createAppointmentToken = async (
  appointmentId: string,
  actionType: "confirm" | "cancel" | "client_cancel",
  expiresInDays = 7
): Promise<string | null> => {
  try {
    const token = generateUniqueToken();
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + expiresInDays);

    const { error } = await supabase.from("appointment_tokens").insert({
      appointment_id: appointmentId,
      token,
      action_type: actionType,
      expires_at: expiresAt.toISOString(),
    });

    if (error) {
      console.error("Erreur lors de la création du token:", error);
      return null;
    }

    return token;
  } catch (error) {
    console.error("Erreur lors de la création du token:", error);
    return null;
  }
};
